module.exports = {"TXTWCL_Sorry___an_error_has_occurred":{"id":"TXTWCL_Sorry___an_error_has_occurred","defaultMessage":"Helaas - er is een fout opgetreden"}}